import Icon from '../components/Icon.vue'

Icon.register({
  otter: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M608 32c17.7 0 32 14.3 32 32v32c0 53-43 96-96 96h-22.9l-92.5 49.8 55.1 110.2h28.2c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16h-80l-74.5-144.5-149.5 80.5h64c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16h-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h112c17.7 0 32 14.3 32 32s-14.3 32-32 32h-108.5c-39.4 0-75.5-26.9-82.3-65.7-4.9-28.1 5-54.2 23.2-71.8 23.6-22.8 39.6-52.1 39.6-84.9v-1.6c0-106 86-192 192-192h56l153.3-87.6c9.7-5.5 20.6-8.4 31.8-8.4h20.5 0c14.6 0 34.9 8.4 45.2 18.8l13.3 13.3h32zM512 48c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM544 144c20.8 0 38.4-13.4 45-32h-77l-118.6 59.3 13.8 27.5 101.8-54.8h35z'
      }
    ]
  }
})
